export const TRANSACTION_REJECTED_ATTEMPT = "TRANSACTION_REJECTED_ATTEMPT";
export const TRANSACTION_REJECTED_SUCCESS = "TRANSACTION_REJECTED_SUCCESS";
export const TRANSACTION_REJECTED_FAILED = "TRANSACTION_REJECTED_FAILED";
export const LOGOUT = "LOGOUT";